import {
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const GiftAidStatusFilter = ({ setFilter, value, setValue}) => {

  const handleChange = (event) => {
    setValue((prev)=>({
      ...prev,
      gift_aid_claimed:event.target.value
    }));
    if(event.target.value === 'true'){
      setFilter((prev)=>({
        ...prev,
        gift_aid_claimed:"true",
        page:1
      }));
        return
    }
    if(event.target.value === 'false'){
      setFilter((prev)=>({
        ...prev,
        gift_aid_claimed:"false",
        page:1
      }));
        return
    }
  
  };

  return (
    <FormControl>
      <Select
        autoWidth
        displayEmpty 
        placeholder="Gift Aid Claimed"
        size="small"
        value={value.gift_aid_claimed || ""}
        renderValue={(selected) => {
            
            if (selected.length === 0) {
              return (<Typography variant="big">Gift Aid Claimed</Typography>);
            }
  
            return selected
          }}
        sx={{
          borderRadius: "16px",
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              boxShadow: "none",
              border: "1px solid",
              borderColor: "grey.main",
            },
          },
        }}
        onChange={(event) => handleChange(event)}
        id="demo-simple-select"
      >
        <MenuItem value={"true"}>True</MenuItem>
        <MenuItem value={"false"}>False</MenuItem>
      </Select>
    </FormControl>
  );
};

export default GiftAidStatusFilter;
